export default "__VITE_ASSET__BX79giVM__"